import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBox, faHandHoldingDollar, faReceipt,
} from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import {
  Box, DashboardModule, Grid, LineChart, Text,
} from '@domain-group/suit-theme'

import type { AgencyModel } from '@models/types'

import Item from './Item'

type AgencyOrderGraphProps = {
  agency: AgencyModel,
}
const AgencyOrderGraph = (props: AgencyOrderGraphProps) => {
  const { agency } = props

  const { count, value: orders } = digObject(agency, 'provider_metrics.metrics.orders', {})
  const { total } = digObject(agency, 'provider_metrics.metrics.invoices.outstanding', {})

  const mappedMonthlyValues = orders?.monthly?.map((
    { label, value }: { label: string, value: number },
  ) => ({ label, orders: value })) || []

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large', paddingBottom: 'large' }}
      loading={!agency.provider_metrics}
      title="Agency Order History"
    >
      <Box flexDirection="column">
        <Grid
          // @ts-expect-error TS2322
          gridAutoRows="1fr"
          gridTemplateColumns="repeat(3, minmax(152px, 1fr))"
          gridTemplateRows="repeat(1, minmax(76px, 1fr))"
          borderBottom="1px solid"
          borderColor="lineColor"
          marginBottom="large"
        >
          <Item icon={<FontAwesomeIcon icon={faBox} />} label="Total Orders">
            <Text fontSize="small">
              {count?.ytd}
            </Text>
          </Item>

          <Item
            icon={<FontAwesomeIcon icon={faHandHoldingDollar} />}
            label="Total (YTD)"
          >
            <Text fontSize="small">
              {formatMoney(orders?.ytd)}
            </Text>
          </Item>

          <Item icon={<FontAwesomeIcon icon={faReceipt} />} label="Unpaid">
            <Text fontSize="small">{formatMoney(total)}</Text>
          </Item>
        </Grid>

        <Box paddingRight="50px">
          <LineChart
            // @ts-expect-error TS2739
            dataPayload={{
              dataArray: mappedMonthlyValues,
              dataKeys: ['orders'],
            }}
            showXAxis
            showYAxis
          />
        </Box>
      </Box>
    </DashboardModule>
  )
}

export default AgencyOrderGraph
